import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, Stack } from '@emburse/embark-core';
import { SkeletonDataGrid } from '../../components';
import { buildParametersColumn, ruleColumn, statusColumn } from '../../views/CorpAuditConfig/DataGrid/Columns';
export default function CorpAuditConfigDetectionRulesSkeleton() {
    return (_jsxs(Stack, { alignItems: "flex-start", sx: { width: '100%' }, spacing: 4, children: [_jsx(Skeleton, { variant: "rect", width: "20%", height: 30 }), _jsx(SkeletonDataGrid, { sx: { width: '100%' }, columns: [statusColumn, ruleColumn, buildParametersColumn('', () => { })], columnHeaderHeight: 0, rows: [], loading: true })] }));
}
